module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "EPI"
  }, [_vm._v("As far as the laws of mathematics refer to reality, they are not certain; and as far as they are certain, they do not refer to reality.")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_vm._v("—Albert Einstein, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Sidelights on Relativity")]), _vm._v(" (1922)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efe7073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0